import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

import { isLandscape } from '../../../assets/scripts/utilities/media-queries.js'

class IntroVideoOverlayComponent extends Component {
  init() {
    this.closeButton = this.element.querySelector('.button--close')
    this.closeButton?.addEventListener('click', () => this.closeOverlay())

    this.startButton = this.element.querySelector('.button--start')
    this.startButton?.addEventListener('click', event => this.startVideo(event))

    this.logo = this.element.querySelector('.logo')
    this.logo?.addEventListener('click', () => this.closeOverlay())

    window.addEventListener('fetch-data', event => this.onFetchData(event))
    this.element.reinitAfterFetch = () => this.onFetchData({ detail: this.data })
  }

  onFetchData(event = {}) {
    if (!event.detail) {
      return
    }

    this.data = { ...event.detail }

    this.videos = this.data.videos?.length ? [...this.data.videos] : []
    this.videos = this.videos.filter(video => video.is_released)

    if (!this.videos.length) {
      return
    }

    const video = this.videos.reduce((a, b) => (a.release_offset < b.release_offset ? a : b))

    if (!video || !video.portrait || !video.landscape) {
      return
    }

    // eslint-disable-next-line
    if (environment === 'development') {
      video.portrait = video.portrait[0] === '/' ? `https://static.nos.bevrijding.fabriquehq.nl${video.portrait}` : video.portrait
      video.landscape = video.landscape[0] === '/' ? `https://static.nos.bevrijding.fabriquehq.nl${video.landscape}` : video.landscape
    }

    this.closeButton?.setAttribute('hidden', 'hidden')

    const portraitSource = document.createElement('source')
    const landscapeSource = document.createElement('source')

    portraitSource.src = video.portrait
    portraitSource.type = 'video/mp4'
    portraitSource.media = 'max-width: 799px'
    portraitSource.width = 800
    portraitSource.height = 1734

    landscapeSource.src = video.landscape
    landscapeSource.type = 'video/mp4'
    landscapeSource.media = 'min-width: 800px'
    landscapeSource.width = 1920
    landscapeSource.height = 1080

    const videoElement = document.createElement('video')
    videoElement.classList.add('intro-video-overlay__video')
    videoElement.setAttribute('playsinline', '')
    videoElement.setAttribute('hidden', '')
    videoElement.setAttribute('controls', '')
    videoElement.src = isLandscape() ? landscapeSource.src : portraitSource.src
    videoElement.volume = 0.5

    videoElement.appendChild(portraitSource)
    videoElement.appendChild(landscapeSource)

    this.video = videoElement

    if (window.sessionStorage.getItem('intro-video-watched') === this.video.children[0].src) {
      return
    }

    this.video.addEventListener('ended', () => this.closeOverlay())
    this.element.appendChild(this.video)
    this.startButton.removeAttribute('hidden')
    this.element.removeAttribute('hidden')
    document.documentElement.classList.add('prevent-scrolling')
  }

  closeOverlay() {
    if (this.video) {
      this.video.pause()
      window.sessionStorage.setItem('intro-video-watched', this.video.children[0].src)
      ;[...this.video.children].forEach(child => child.remove())
      this.video.setAttribute('hidden', 'hidden')
    }

    this.element.setAttribute('hidden', 'hidden')
    document.documentElement.classList.remove('prevent-scrolling')
  }

  startVideo(event = {}) {
    event?.preventDefault()

    if (!this.video) {
      return
    }

    this.video.removeAttribute('hidden')
    this.video.play()

    this.closeButton?.removeAttribute('hidden')
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'intro-video-overlay', IntroVideoOverlayComponent))
